import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import IdeaRefiner from './pages/idea-refiner';
import SynthesizePage from './pages/synthesize';
import Dashboard from './pages/dashboard';
import PostDetails from './pages/post-details';

import OAuthIntegrationSetup from './pages/o-auth-integration-setup';
import WritingStylesTemplates from './pages/writing-styles-templates';
import AuthenticationLanding from './pages/authentication-landing';
import Login from './pages/login';
import UserProfileManagement from './pages/user-profile-management';
import Feedback from './pages/feedback';
import Sidebar from './components/navigation/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import InsightLabAnalyticsDashboard from './pages/insight-lab-analytics-dashboard';
import EngagementTrackerTrendingAlerts from './pages/engagement-tracker-trending-alerts';
import OAuthCallback from './pages/oauth-callback';
import LandingPageAnalytics from './pages/landing-page-analytics';
import Pricing from './pages/pricing';
import SchedulePage from './pages/schedule';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';

const RoutesContent = () => {
  useGoogleAnalytics();
  
  return (
    <RouterRoutes>
      {/* Public Routes */}
      <Route path="/" element={<AuthenticationLanding />} />
      <Route path="/login" element={<Login />} />
      
      {/* Protected Routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <div className="app-layout">
              <Sidebar />
              <main className="app-content">
                <RouterRoutes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/idea-refiner" element={<IdeaRefiner />} />
                  <Route path="/synthesize" element={<SynthesizePage />} />
                  <Route path="/preview-mode" element={<Navigate to="/idea-refiner" replace />} />
                  <Route path="/post/:id" element={<PostDetails />} />
                  <Route path="/insight-lab-analytics-dashboard" element={<InsightLabAnalyticsDashboard />} />
                  <Route path="/landing-page-analytics" element={<LandingPageAnalytics />} />
                  <Route path="/engagement-tracker-trending-alerts" element={<EngagementTrackerTrendingAlerts />} />
                  <Route path="/o-auth-integration-setup" element={<OAuthIntegrationSetup />} />
                  <Route path="/writing-styles-templates" element={<WritingStylesTemplates />} />
                  <Route path="/schedule" element={<SchedulePage />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/profile" element={<UserProfileManagement />} />
                  <Route path="*" element={<NotFound />} />
                </RouterRoutes>
              </main>
            </div>
          </ProtectedRoute>
        }
      />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/oauth-callback" element={<OAuthCallback />} />
    </RouterRoutes>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <ErrorBoundary>
            <ScrollToTop />
            <RoutesContent />
          </ErrorBoundary>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
